export enum UserRole {
  System = 'System',
  SystemAdmin = 'System admin',

  User = 'User'
}
